import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QAReportDashboardRoutingModule } from './qa-report-dashboard-routing.module';
import { QAReportDashboardComponent } from '../qa-report-dashboard/qa-report-dashboard.component';
import { QaDashboardComponent } from './qa-dashboard/qa-dashboard.component';
import { QaReportGridComponent } from './qa-report-grid/qa-report-grid.component';
import { QaUploadReportComponent } from './qa-upload-report/qa-upload-report.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../core/material.module';
import { SharedModule } from '../shared/shared.module';
import { QaReportComponent } from './qa-report/qa-report.component';
import { AgGridModule } from 'ag-grid-angular';
import {GoogleChartsModule} from 'angular-google-charts'
import { ExpandMode, NgxTreeSelectModule } from '../../ngx-tree-select/src';


@NgModule({
  declarations: [
    QAReportDashboardComponent,
    QaDashboardComponent,
    QaReportGridComponent,
    QaUploadReportComponent,
    QaReportComponent
  ],
  imports: [
    CommonModule,
    QAReportDashboardRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    GoogleChartsModule,
    AgGridModule.withComponents([]),
    NgxTreeSelectModule.forRoot({
          idField: 'id',
          textField: 'name',
          expandMode: ExpandMode.Selection,
        })
  ],
  exports:[
    QAReportDashboardComponent,
    QaDashboardComponent,
    QaReportGridComponent,
    QaUploadReportComponent,
    GoogleChartsModule
  ]
})
export class QAReportDashboardModule { }
